<template>
<div>
    <!-- 我购买的私教课 -->
    <div v-if="list && list!=''" class="model-box ptn course-list bcw">
        <div class="model-box__bd clear mtm bcw">
            <!-- <course-card v-for="(item,index) in list" :key="item.id" :course="item"></course-card> -->
            <van-list v-model="listLoading" :finished="listFinished" @load="onLoadMore" loading-text="努力加载中...">
                <van-row gutter="20">
                    <van-col v-for="(item,index) in list" :key="index" span="12">
                        <router-link :to="{name:'coachcourseitem',params: { courseId: item.courseId}}" class="private-card tac">
                            <div class="private-card__pic">
                                <img v-if="item.picture" :src="item.picture" :alt="item.title">
                                <img v-else src="../assets/imgs/true.jpg" alt="item.title">
                            </div>
                            <div class="fs3 mtn c4 private-card__uname">{{item.title}}</div>
                            <div class="fs1 private-card__dis mtn">
                                <span class="price fs2">￥{{item.price}}/课时</span>
                                <router-link :to="{name: 'courseappointment',params: {orderId:item.orderId,itemId:item.courseId,coachId:item.coachId,type:'clubPtCourse'}}" class="right">
                                    <span class="buy"><button class="van-button van-button--primary van-button--small">预约</button></span>
                                </router-link>
                            </div>
                        </router-link>
                    </van-col>
                </van-row>
            </van-list>   
        </div>        
    </div>
    <div v-else class="tac norecord">
        <i class="iconfont">&#xe646;</i><br/>
        暂无记录，请先购买私教课
    </div>
    </div>
</template>
<script>
import Vue from 'vue';
import CourseCard from '@/components/CourseCard';
import { List } from 'vant';
Vue.use(List);
export default {
    name: 'CourseList',
    components: {
        CourseCard
    },
    data(){
      return {
        list:[],  // 团课列表
        listLoading: false,
        listFinished: false,
        page: 1,
        pageSize: 10
      }
    },
    created(){
        this.getList();
    },
    methods:{
        onLoadMore() {
            // console.log('加载更多'); 
            this.page++ 
            this.getList();   
        },
        getList(){
            let _this = this
            // 取私教课列表
            // console.log('进入page',_this.page)
            this.$http.post('club_pt_course/getList',{
                page:_this.page,
                limit:_this.pageSize
            }).then(function(res){
                // console.log(res)
                if(!res.data.code){ 
                    let re = res.data.value               
                    _this.list = _this.list.concat(re.list)

                    _this.listLoading = false;
                    if (re.list.length < _this.pageSize) {
                        _this.listFinished = true;
                    }                  
                    // console.log('最终page',_this.page) 
                    // console.log(_this.list)             
                }else{
                    _this.listFinished = true;
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
// 私教课卡片
.private-card{
    position: relative;
    display: block;
    text-align: left;
    margin: 0 0 0.15rem 0;
    box-shadow: rgba(0, 0, 0, 0.2) 0 0 0.05rem;
    padding: .1rem .1rem .15rem;
    &__pic{
        width: 100%;height: 1.5rem;border-radius:.03rem;
        overflow: hidden;
        &>img{
            width: 100%;height: 100%;object-fit: cover;
        }
    }
    &__dis{
        & .price{
            color:#FFA800;
        }
        & .buy button{
            position: absolute;
            right: .1rem;
            bottom: .15rem;
            height: .22rem;
            min-width: .4rem;
            line-height: 0.1rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/MyCourseList.vue